var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1677,
    height: 896,
    viewBox: "0 0 1677 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_1636)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "#C6E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189 585C1190.5 615.167 1182.1 679.6 1136.5 696C1116.52 703.185 1098.69 705.002 1084 704.117M882.499 503C938.499 514.2 976.166 560.333 988 582C983.499 662 1020.83 677.833 1045 693C1051.46 697.401 1065.15 702.981 1084 704.117M1108.5 428C1066 415.5 969.499 521.5 1092.5 576C1150.5 608 1273 595.5 1248.5 455.5C1258.5 434.5 1269.2 382.4 1232 342C1232.5 320 1216 272.2 1146 257C1146.5 220.833 1123.9 149.9 1029.5 155.5M1029.5 155.5C1040.5 249 1016 279.5 954.499 329.5M1029.5 155.5C1001.78 88.5735 903.913 82.2008 865.499 124.024M865.499 216C842.334 175.179 847.089 144.067 865.499 124.024M954.499 329.5C933.499 347.833 893.199 395.2 899.999 438M954.499 329.5C966.499 382.5 990.499 458 876.499 472.5C852.999 482.667 810.099 527 826.499 623M826.499 623C834.498 644.667 861.498 689.6 905.498 696C926.498 716.5 936.498 755.5 934.498 810.5C947.998 849 1041.8 780.4 1041 734M826.499 623C811.498 637.5 768.198 659.6 714.998 632M1041 734C1012.16 739 949.598 735.8 929.998 683M1041 734C1050.33 731.078 1072 721.01 1084 704.117M714.998 632C679.831 643.333 604.598 643.2 584.998 552M714.998 632C746.999 609.167 793.488 565.5 698 493C671 472.5 661.5 414 684 389M584.998 552C557.998 557.833 497.098 555.3 469.498 498.5M584.998 552C610.165 540.667 644.2 498 579 418C546.4 378 576.5 326.5 603 326.5M469.498 498.5C458.998 467.833 451.398 408.8 504.998 418M469.498 498.5C450.998 484 416.098 443.3 424.498 396.5C413.333 365.167 409.501 295.9 483.501 269.5C484 239.333 505.2 178 586 174M586 174C600.167 145.833 647.7 97.5 724.5 129.5M586 174C582.5 190.667 579.1 225.6 593.5 232M724.5 129.5C745.832 106.683 803.898 73.6434 865.499 124.024M724.5 129.5C751.167 150.833 795.121 202.444 784.5 246.5C771 302.5 842.5 344.5 899.999 356M593.5 232C606.5 227.167 639.1 219.5 665.5 227.5M593.5 232C578.833 235.667 553.5 254 553.5 326.5C553.5 384.674 501 400 455.5 400",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.5 233.5C759.833 252.5 754 291.5 779.5 353C802.635 408.797 736.833 437.5 700 448.5M1032 270C1069.83 268 1146.9 284.4 1152.5 366C1158.47 453 1181 497 1212 511",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 448,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 653,
    cy: 446,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 402,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 490,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 460,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461,
    cy: 360,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337,
    cy: 365,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 244,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 184,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 297,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 236,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 584,
    cy: 350,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 223,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 158,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 711,
    cy: 190,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 259,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739,
    cy: 335,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 833,
    cy: 317,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 259,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961,
    cy: 216,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939,
    cy: 129,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 139,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798,
    cy: 172,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936,
    cy: 77,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1047,
    cy: 335,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 971,
    cy: 418,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908,
    cy: 389,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814,
    cy: 406,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 935,
    cy: 551,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888,
    cy: 595,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027,
    cy: 538,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093,
    cy: 576,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104,
    cy: 484,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104,
    cy: 690,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 788,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 968,
    cy: 725,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 927,
    cy: 717,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 876,
    cy: 734,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 993,
    cy: 633,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926,
    cy: 474,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1058,
    cy: 448,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817,
    cy: 672,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 677,
    cy: 680,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667,
    cy: 694,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556,
    cy: 655,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 690,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 680,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 527,
    cy: 776,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467,
    cy: 696,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204,
    cy: 431,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1354,
    cy: 377,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 345,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1144,
    cy: 307,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1123,
    cy: 245,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260,
    cy: 214,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1288,
    cy: 157,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1463,
    cy: 136,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1517,
    cy: 495,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.5 533.5V512.5M616.5 533.5L673 496M616.5 533.5L596.5 566M616.5 533.5L681.5 568M616.5 533.5L636.205 566.934M616.5 512.5L645 481.067M616.5 512.5L673 496M673 496L681.5 568M673 496L645 481.067M673 496L679.5 466.5M673 496L718 521.5M605.5 460L583.5 550.5M605.5 460L579.5 419M605.5 460L621.5 439.5M605.5 460L575 444.5M605.5 460L645 481.067M605.5 460L679.5 466.5M605.5 460L653 446.5M605.5 460L562.5 490M583.5 550.5L562.5 490M583.5 550.5L556.435 532.457M583.5 550.5L474.5 965.5L667.5 693.5M583.5 550.5L596.5 566M562.5 490L531 515.5M562.5 490L512.5 479.5M562.5 490L556.435 532.457M562.5 490L575 444.5M562.5 490L531 444.5M562.5 490L517 506M528.5 533.5L553.5 553L556.435 532.457M528.5 533.5L531 515.5M528.5 533.5L523.5 547L212 910M528.5 533.5L556.435 532.457M528.5 533.5L503.5 527M531 515.5L517 506M531 515.5L556.435 532.457M531 515.5L503.5 527M512.5 479.5L517 506M512.5 479.5L531 444.5M512.5 479.5L474.5 460M512.5 479.5L482 496M517 506L503.5 527M517 506L482 496M503.5 527L482 496M503.5 527H487.5L482 496M482 496L474.5 460M482 496H468.5M474.5 460L503.5 419M474.5 460L531 444.5M503.5 419L531 444.5M503.5 419L462 450.5M503.5 419L474.5 424M503.5 419H579.5M503.5 419L512.5 405.227M531 444.5L579.5 419M531 444.5H575M579.5 419L575 444.5M579.5 419L536.5 368.5M579.5 419L512.5 405.227M579.5 419L621.5 439.5M579.5 419H605.5M579.5 419L577.5 385.256M641.5 402.5L621.5 439.5M641.5 402.5L605.5 419M641.5 402.5L619 383.5M641.5 402.5L662 405M641.5 402.5L653 446.5M641.5 402.5L684.5 388.5M621.5 439.5L653 446.5M621.5 439.5L605.5 419M468.5 496L-11.5 695.5L423 456M468.5 496L423 456M423 456L432.5 450.5M423 456L-23 -12M432.5 450.5H462M432.5 450.5L456 399M462 450.5L456 399M474.5 424L456 399M474.5 424L499 393.5M456 399L482 388.5M456 399L447 388.5M536.5 368.5L512.5 405.227M536.5 368.5L566.5 372M536.5 368.5L517 377M536.5 368.5L547 337.5M511 404.5L499 393.5M499 393.5L482 388.5M667.5 693.5L712 633M667.5 693.5L301.5 910M667.5 693.5L748 643.5M712 633L702 621.5M712 633L740.5 623M712 633L740.5 631.97M712 633L720 609.5M702 621.5L677.5 637L668.773 622.192M702 621.5L681.5 568M702 621.5L668.773 622.192M702 621.5L720 609.5M596.5 566L636.205 566.934M596.5 566L601.5 594.5M681.5 568L740.5 561M681.5 568L718 521.5M681.5 568L636.205 566.934M681.5 568L668.773 622.192M681.5 568L720 609.5M681.5 568L731.5 594.5M740.5 561L731.5 594.5M740.5 561L755 545M740.5 561L729.25 541.25M718 521.5L716 508M718 521.5L729.25 541.25M718 521.5L736 527L729.25 541.25M630 623L636.205 566.934M630 623L668.773 622.192M630 623L-11.5 910M636.205 566.934L601.5 594.5M636.205 566.934L668.773 622.192M601.5 594.5L668.773 622.192M720 609.5L731.5 594.5M720 609.5L743.5 605L731.5 594.5M731.5 594.5L755 573M755 573V545M755 573L814 553M755 573L757.5 594.5M755 545L768.5 512.5M755 545L785 533.5M755 545L729.25 541.25M755 545L814 553M782 480L716 508M782 480H743M782 480L825 515.5M782 480L768.5 512.5M782 480L757.5 435.5M782 480L789.5 431M782 480L839.5 435.5M782 480L846 479.5M716 508L708 487M716 508L825 515.5M716 508L743 480M708 487L702 449M708 487L679.5 466.5M708 487L743 480M702 449L679.5 466.5M702 449L673 427.5M702 449L743 480M702 449L711 399.5M702 449L684.5 388.5M702 449L743 419M679.5 466.5L645 481.067M679.5 466.5L653 446.5M653 446.5L673 427.5M653 446.5L662 405M605.5 419L619 383.5M605.5 419L577.5 385.256M619 383.5L610 348.5M619 383.5L577.5 385.256M619 383.5L684.5 388.5M610 348.5H584.5M610 348.5L577.5 385.256M610 348.5L684.5 388.5M610 348.5L605.5 326.5M610 348.5L587.5 330M584.5 348.5L579.5 360M584.5 348.5L547 337.5M584.5 348.5L577.5 340.479M579.5 360L566.5 372M579.5 360L577.5 385.256M566.5 372L577.5 385.256M566.5 372L547 337.5M684.5 388.5L605.5 326.5M684.5 388.5L662 346M684.5 388.5L662 405M684.5 388.5L711 399.5M684.5 388.5L698 366M684.5 388.5L681 328.5M605.5 326.5L662 346M605.5 326.5L677.5 288.5M605.5 326.5L643.25 327.5M605.5 326.5L630.5 284.5M605.5 326.5L603.917 288.5M605.5 326.5L566.5 279.5M605.5 326.5L556 294M605.5 326.5L587.5 330M662 346L681 328.5M673 427.5L662 405M743 480L731.5 436.5M743 480L757.5 435.5M711 399.5L743 419M711 399.5L728 366M711 399.5L698 366M711 399.5L753 382M711 399.5L770 387M825 515.5L785 533.5M825 515.5L846 500M825 515.5L830.5 531.5M785 533.5L768.5 512.5M785 533.5L814 553M785 533.5L830.5 531.5M731.5 436.5L757.5 435.5M731.5 436.5L743 419M757.5 435.5L789.5 431M757.5 435.5L768 411.5M789.5 431L839.5 435.5M789.5 431L814.5 406.5M789.5 431L768 411.5M814 553L811 594.5M814 553L830.5 531.5M814 553L825 566.934M811 594.5H757.5M811 594.5L825 621.5M811 594.5L795 630M811 594.5L825 566.934M757.5 594.5L740.5 623M757.5 594.5L795 630M740.5 623L795 630M740.5 623V631.97M825 621.5L795 630M825 621.5L759.5 938M825 621.5L839.5 598M825 621.5L855.5 653M795 630L748 643.5M795 630L740.5 631.97M839.5 435.5L846 479.5M839.5 435.5L814.5 406.5M839.5 435.5L849.5 409M839.5 435.5L887 428.5M846 479.5V500M846 479.5L887 428.5M846 479.5L875 475.5M846 500H882M743 419L770 387M743 419L768 411.5M482 388.5V368.5M482 388.5L547 337.5M482 388.5L517 377M482 368.5L447 388.5M482 368.5L517 337.5M447 388.5L420.5 341M447 388.5L459.5 360M447 388.5L425.5 396.5L-11.5 383.5M420.5 341L459.5 360M420.5 341L-11.5 466.5M420.5 341L442 334.5M459.5 360L442 334.5M459.5 360L462 300.5M459.5 360L517 337.5M442 334.5L438.5 300.5M442 334.5L462 300.5M438.5 300.5H462M438.5 300.5L-23 179M462 300.5L517 337.5M462 300.5L520 297M462 300.5L484 270M517 337.5L520 297M517 337.5V377M517 337.5H547M517 337.5L539 316M520 297L539 316M520 297L547 311M520 297L544 291.5M484 270L544 291.5M484 270L-23 34L499 259M484 270L499 259M484 270L499 236.5M547 337.5L539 316M547 337.5V311M547 337.5L577.5 340.479M547 311L544 291.5M544 291.5L521.5 264M544 291.5L553 272M544 291.5L499 259M499 236.5L553 242.5M499 236.5L521.5 264M499 236.5V259M499 236.5L534 208.5M499 236.5L528 201.5M499 236.5L502.5 211M553 242.5V272M553 242.5L521.5 264M553 242.5L534 208.5M553 242.5L551 211M553 242.5L577.5 215M553 242.5H602M553 272L521.5 264M553 272L569 255.25M521.5 264L499 259M534 208.5L551 211M534 208.5L544 187.5M534 208.5L528 201.5M551 211L577.5 215M551 211L569 203.8M728 366H698M728 366L753 382M728 366L719 338.5M728 366L739 335M728 366L748.5 362.5M698 366L719 338.5M698 366L681 328.5M698 366L696 338.5M753 382L748.5 362.5M753 382L770 387M753 382L773 360M719 338.5L739 335M739 335L748.5 362.5M739 335L756 347M739 335L748.5 330M739 335L696 338.5M739 335L776 340M739 335L681 328.5M681 328.5L643.25 327.5M681 328.5L671.5 312.5M681 328.5L677.5 288.5M681 328.5L690 305.5M681 328.5L696 321M681 328.5L696 338.5M677.5 288.5L643.25 327.5M677.5 288.5L648.25 255.25M677.5 288.5L630.5 284.5M677.5 288.5L666 226M677.5 288.5L709.5 259M677.5 288.5L671.5 312.5M677.5 288.5L690 305.5M643.25 327.5L671.5 312.5M602 242.5L630.5 284.5M602 242.5L625.273 236.5M602 242.5L603.917 288.5M602 242.5L566.5 279.5M602 242.5L569 255.25M630.5 284.5L648.25 255.25M630.5 284.5L625.273 236.5M630.5 284.5L603.917 288.5M666 226L648.25 255.25M666 226L709.5 259M666 226L765.5 233M666 226L674 215M666 226L645.636 231.25M666 226L629 215.817M648.25 255.25L625.273 236.5M648.25 255.25L645.636 231.25M625.273 236.5L611.5 223.5M625.273 236.5L645.636 231.25M603.917 288.5L566.5 279.5M566.5 279.5L556 294M709.5 259L765.5 233M709.5 259L690 305.5M709.5 259L711.5 300M709.5 259L730.5 265.5M765.5 233L735.5 197M765.5 233L674 215M765.5 233L753 244.607M765.5 233L784 216M765.5 233L758.5 177M765.5 233L768 156.5M765.5 233L784 253M663.5 182L635 158.5M663.5 182L674 215M663.5 182L695.5 165M663.5 182L652.5 205.5M663.5 182L614 197M663.5 182L654 158.5M635 158.5L614 197M635 158.5L598.5 192M635 158.5H603.917M635 158.5H654M635 158.5L628 139M635 158.5L647 144M614 197L611.5 223.5M614 197L652.5 205.5M614 197L598.5 192M614 197L629 215.817M611.5 223.5L598.5 192M611.5 223.5L589 211M611.5 223.5L629 215.817M674 215L695.5 165M674 215L711.5 190M674 215L652.5 205.5M674 215L735.5 197M695.5 165L711.5 190M695.5 165L698 139M695.5 165L718 153.5M711.5 190L735.5 197M711.5 190L718 153.5M711.5 190L740 174.5M711.5 190L758.5 177M652.5 205.5L629 215.817M598.5 192L589 211M598.5 192L569 203.8M598.5 192L586.5 174.5M598.5 192L603.917 158.5M589 211L577.5 215M577.5 215L569 203.8M577.5 215L569 255.25M544 187.5L528 201.5M544 187.5L569 203.8M544 187.5L586.5 174.5M544 187.5L530 189M528 201.5L502.5 211M528 201.5L530 189M502.5 211L-11.5 140M586.5 174.5L603.917 158.5M586.5 174.5L484 -25.5M603.917 158.5L628 139M530 189L452.5 -13.5M556 294L587.5 330M556 294L560.5 321M587.5 330L560.5 321M560.5 321L577.5 340.479M690 305.5L711.5 300M690 305.5L696 321M735.5 197L758.5 177M654 158.5L698 139M654 158.5L647 144M628 139L706 -38.5L723.5 129M628 139L677.5 124.5M628 139L647 144M723.5 129L718 153.5M723.5 129L677.5 124.5M723.5 129L732 145.5M723.5 129L711.5 133.706M723.5 129L754.5 126.5M698 139L677.5 124.5M698 139L647 144M698 139L718 153.5M698 139L711.5 133.706M647 144L677.5 124.5M718 153.5L740 174.5M718 153.5L732 145.5M718 153.5L711.5 133.706M711.5 300L696 321M711.5 300L715.5 324.5M711.5 300L748.5 330M711.5 300L751 275.5M711.5 300L730.5 265.5M711.5 300L749.491 308.405M696 321L715.5 324.5M715.5 324.5L748.5 330M715.5 324.5L696 338.5M748.5 330H765M748.5 330L749.491 308.405M751 275.5L730.5 265.5M751 275.5L753 244.607M751 275.5L761 255.25M751 275.5L780.5 289.5M751 275.5L749.491 308.405M730.5 265.5L753 244.607M753 244.607L761 255.25M748.5 362.5L756 347M748.5 362.5L773 360M756 347L773 360M770 387L768 411.5M770 387L773 360M770 387L781 376M814.5 406.5L768 411.5M814.5 406.5L855.5 355.5M814.5 406.5L810 347M814.5 406.5L791.5 391M814.5 406.5L849.5 409M814.5 406.5L871 387M768 411.5L791.5 391M732 145.5L740 174.5M732 145.5L758.5 177M732 145.5L711.5 133.706M732 145.5L737.5 140.856M740 174.5L758.5 177M754.5 126.5L768 156.5M754.5 126.5L784 107M754.5 126.5L737.5 140.856M754.5 126.5L814 131.5M754.5 126.5L758.5 105.5L784 107M768 156.5L814 131.5M768 156.5L737.5 140.856M768 156.5L798 172M814 131.5L784 107M814 131.5L798 172M814 131.5L824 115.5M814 131.5L830.5 140.856M784 107L824 115.5M784 107L795 97L824 115.5M737.5 140.856L784.5 191M798 172L784.5 191M798 172L802 216M798 172L830.5 140.856M798 172L841 167M798 172L843 209.5M784.5 191L784 216M784.5 191L802 216M784 216L792 233M802 216L792 233M802 216L810 259M802 216L843 209.5M792 233L810 259M792 233L784 253M810 259L814.5 283.5M810 259L794 275.5M810 259L843 209.5M810 259L833.5 261.5M773 360L781 376M768 312.5L799.594 314.671M768 312.5L791.5 294.72M768 312.5L749.491 308.405M833.5 317L814.5 283.5M833.5 317L810 303.5M833.5 317L878 279.5M833.5 317L878 312.5M833.5 317L878 341M833.5 317L799.594 314.671M814.5 283.5L794 275.5M814.5 283.5L810 303.5M814.5 283.5L833.5 261.5M814.5 283.5L878 279.5M794 275.5L784 253M794 275.5L791.5 294.72M810 303.5L799.594 314.671M810 303.5L791.5 294.72M878 279.5L865.5 216M878 279.5L833.5 261.5M878 279.5V312.5M878 279.5L956 330M878 279.5L961.5 216M878 279.5L938.5 268.5M878 279.5L964.5 305.5M824 115.5L835 105.5L837.5 121M837.5 121L830.5 140.856M837.5 121L850 137M830.5 140.856L850 137M830.5 140.856L841 167M850 137L864.5 159M841 167L850.592 177M843 209.5L833.5 261.5M833.5 261.5L865.5 216M865.5 216H961.5M865.5 216L920.5 202.5M865.5 216L864.5 191.5M878 312.5L956 330M878 312.5V341M956 330L964.5 305.5M956 330L878 341M956 330L900 355.5M956 330L990.5 317M961.5 216L920.5 202.5M961.5 216L938.5 268.5M961.5 216L984.5 183M961.5 216L1023 250.5M961.5 216L997.5 291M961.5 216L964.5 305.5M920.5 202.5L864.5 191.5M920.5 202.5L884.5 175.5M920.5 202.5L940 158M920.5 202.5L984.5 183M938.5 268.5L964.5 305.5M964.5 305.5L1023 250.5M964.5 305.5L997.5 291M855.5 355.5L810 347M855.5 355.5L871 387M855.5 355.5L908.5 389.5M855.5 355.5L823 332.5M855.5 355.5L885 358M810 347L791.5 391M810 347L776 340M810 347L789.5 355.5M810 347L823 332.5M791.5 391L781 376M781 376L789.5 355.5M849.5 409L887 428.5M849.5 409L871 387M849.5 409L908.5 389.5M849.5 409L893.5 403.5M887 428.5L875 475.5M887 428.5L893.5 403.5M887 428.5L900 417M875 475.5L882 500M875 475.5L902 439M882 500L830.5 531.5M882 500L839.5 561M882 500L898.5 530M882 500L902 466M830.5 531.5L839.5 561M839.5 561L825 566.934M839.5 561V598M839.5 561L898.5 530M839.5 561L888 595.5M825 566.934L839.5 598M839.5 598V647L855.5 653M898.5 530L936 551M898.5 530L888 595.5M898.5 530L926.5 521.5M936 551L888 595.5M936 551L926.5 521.5M936 551L971.5 580.5M936 551L965.5 546.809M888 595.5L855.5 653M888 595.5L877.5 674M888 595.5L971.5 580.5M888 595.5L978 621.5M888 595.5L945 633M902 466V439M902 466L926.5 521.5M902 466L925 473.5M902 439L932 453.5M902 439L914 433M926.5 521.5L925 473.5M926.5 521.5L971.5 494M926.5 521.5L1027.5 538M925 473.5L949 453.5M925 473.5L971.5 494M925 473.5L932 453.5M776 340L757 346M776 340L823 332.5M776 340L799.594 314.671M776 340L776.871 341M789.5 355.5L776.871 341M871 387L908.5 389.5M908.5 389.5L893.5 403.5M908.5 389.5L900 355.5M908.5 389.5L885 358M908.5 389.5L962 360M908.5 389.5L917.5 417M908.5 389.5L957.7 346M908.5 389.5L975.5 384.5M823 332.5L799.594 314.671M784 253L761 255.25M784 253L780.5 289.5M761 255.25L780.5 289.5M780.5 289.5L791.5 294.72M765 330L776.871 341M765 330L749.491 308.405M748 643.5L740.5 631.97M864.5 191.5L884.5 175.5M864.5 191.5L850.592 177M884.5 175.5L873 139M884.5 175.5L864.5 159M884.5 175.5L940 158M873 139L864.5 159M873 139L940 158M873 139L895 115.5M864.5 159L850.592 177M940 158L938.5 129M940 158L895 115.5M940 158L984.5 183M938.5 129L895 115.5M938.5 129L933.5 105.5M938.5 129L965.5 110.5M938.5 129L997.5 130.5M938.5 129L984.5 183M895 115.5L933.5 105.5M895 115.5L865.5 124.5L940 -38.5L982.5 108M895 115.5L901.5 102.5L933.5 105.5M933.5 105.5L965.5 110.5M984.5 183L997.5 130.5M984.5 183L1015.5 153.5M984.5 183L1022 170.5M984.5 183L1023 250.5M984.5 183L1032 194M965.5 110.5L997.5 130.5M965.5 110.5L944.5 97L890 -45M965.5 110.5L982.5 108M997.5 130.5L1015.5 153.5M997.5 130.5L982.5 108M997.5 130.5L1013 129M1015.5 153.5L1013 129M1015.5 153.5L1029.5 155M982.5 108L806.5 -15.5M1022 170.5L1029.5 155M1022 170.5L1032 194M1032 270.5L1023 250.5M1032 270.5L1047 335M1032 270.5L997.5 291M1032 270.5L990.5 317M1032 270.5L1050 221M1032 270.5L1057 245.5M1032 270.5L1044 276.5M1023 250.5L1050 221M1089 181.5L1050 221M1089 181.5L1032 194M1089 181.5L1118 210M1089 181.5L1112 178M1089 181.5L1062 156.5L1044 173.5M1089 181.5L1044 173.5M997.5 291L990.5 317M900 355.5L885 358M990.5 317L1002 358M990.5 317L1047 335M990.5 317L957.7 346M1047 335L1002 358M1047 335L1086 382M1047 335L1044 276.5M1047 335L1075.5 284.5M1047 335L1101.5 293.5M1002 358L962 360M1002 358L975.5 384.5M1002 358L1021 409M1002 358L957.7 346M1002 358L1086 382M962 360L975.5 384.5M975.5 384.5L917.5 417M975.5 384.5L914 433M975.5 384.5L1021 409M917.5 417L914 433M917.5 417H900M914 433L900 417M914 433H956M914 433L929.5 439M956 433L949 453.5M956 433L929.5 439M956 433L971.5 419M949 453.5L971.5 494M949 453.5H932M949 453.5L998 447M971.5 419L1021 409M971.5 419L998 447M1021 409L1086 382M1021 409L998 447M1021 409L1097.5 439M1021 409L1057 447M1086 382L1057 447M1086 382L1089 419M1086 382L1122.5 318M1086 382L1101.5 293.5M1086 382L1108.5 430M1086 382L1146 389M1086 382L1142.5 352M971.5 494L998 447M971.5 494L1023 488M971.5 494L1027.5 538M932 453.5L929.5 439M998 447L1023 488M998 447L1039.5 453.5M1023 488L1027.5 538M1023 488L1042 469M1023 488L1035.5 510.5M1027.5 538L991 584.5M1027.5 538L1035.5 510.5M1027.5 538L965.5 546.809M855.5 653V668M855.5 668L-11.5 730.5M855.5 668L877.5 674M877.5 674L945 633M877.5 674L904.5 682M877.5 674L877.29 685.5M971.5 580.5L978 621.5M971.5 580.5L991 584.5M971.5 580.5L965.5 546.809M978 621.5L945 633M978 621.5L991 584.5M978 621.5L987.5 662M978 621.5L992.5 634M945 633L904.5 682M945 633L930.5 682M945 633L987.5 662M945 633L968 685.5M904.5 682H930.5M904.5 682L877.29 685.5M904.5 682V696M872.5 947.5L877.29 685.5M930.5 682L904.5 696M930.5 682L923.5 696M930.5 682L968 685.5M930.5 682L948 696M904.5 696L718 947.5M904.5 696H923.5M923.5 696L927 718M923.5 696L945 708M927 718L928.5 739M927 718L941.5 721M927 718L945 708M928.5 739L941.5 721M928.5 739L968 725.5M928.5 739L948 763M941.5 721L968 725.5M941.5 721L945 708M968 725.5V685.5M968 725.5L972.5 739M968 725.5L948 763M968 725.5L1019.5 693.5M968 725.5L948 696M968 685.5L987.5 662M968 685.5L948 696M968 685.5L1019.5 693.5M987.5 662L1019.5 693.5M987.5 662H1007.5M987.5 662L992.5 634M1019.5 693.5L1007.5 731.5M1019.5 693.5L1051.5 708M1019.5 693.5L1041 734M1019.5 693.5L1033.5 685.5M1019.5 693.5L1007.5 662M1007.5 731.5L972.5 739M1007.5 731.5L1015.5 760M972.5 739L948 763M972.5 739L1015.5 760M972.5 739L987.5 788M948 763L987.5 788M948 763L951.5 800M948 763L933.742 783.5M987.5 788L1015.5 760M987.5 788L951.5 800M987.5 788L962 810.5M987.5 788L1010 790.5M987.5 788L972.5 816.5L962 810.5M1015.5 760L1041 734M1015.5 760L1010 790.5M1041 734L1051.5 708M1041 734L1136.5 925.5M1051.5 708L1033.5 685.5M1051.5 708L1083.5 704M948 696L945 708M839.5 919L933.742 783.5M951.5 800L933.742 783.5M951.5 800L939 816.5M951.5 800L962 810.5M939 816.5L962 810.5M939 816.5L955 905M1010 790.5L1203 905M1032 194L1050 221M1032 194L1044 173.5M1013 129L1265 -20.5M1118 210L1050 221M1118 210L1124 245.5M1118 210L1057 245.5M1118 210L1141 224M1118 210L1112 178M1050 221L1057 245.5M1124 245.5H1057M1124 245.5L1093 261M1124 245.5L1133.5 277.5M1124 245.5L1146 257M1124 245.5L1141 224M1057 245.5L1069 273M1057 245.5L1093 261M1069 273L1044 276.5M1069 273L1075.5 284.5M1069 273L1093 261M1075.5 284.5H1101.5V293.5M1039.5 453.5L1042 469M1039.5 453.5L1057 447M1042 469L1064 455.5M1042 469L1054.5 484M991 584.5L1003.5 633M991 584.5L1050 563M991 584.5L992.5 634M1024.5 653L1003.5 633M1024.5 653L1050 563M1024.5 653L1007.5 662M1024.5 653L1080.5 584.5M1024.5 653L1117.5 598M1024.5 653L1033.5 685.5M1024.5 653L1104 690.5M1003.5 633L1050 563M1003.5 633L992.5 634M1003.5 633L1007.5 662M1050 563L1080.5 584.5M1050 563L1068 559M1080.5 584.5L1117.5 598M1080.5 584.5L1068 559M1080.5 584.5L1093.5 576M1117.5 598L1104 690.5M1117.5 598L1142 671.5M1117.5 598L1167.5 644.5M1117.5 598L1162 603M1117.5 598L1133 588.5M1117.5 598L1093.5 576M1033.5 685.5L1104 690.5M1104 690.5L1083.5 704M1104 690.5L1142 671.5M1104 690.5L1130 698.5M1083.5 704L1280 938M1142 671.5L1167.5 644.5M1142 671.5L1130 698.5M1142 671.5L1162 677M1167.5 644.5L1162 677M1167.5 644.5L1178.5 612M1167.5 644.5L1162 603M1167.5 644.5L1186.5 634L1178.5 612M1130 698.5L1236 925.5M1162 677L1724 725.5M1178.5 612L1162 603M1178.5 612L1188.5 585M1162 603L1133 588.5M1162 603L1188.5 585M1133 588.5L1117.5 576M1133 588.5L1159.5 572M1083.5 551L1068 559M1083.5 551L1093.5 576M1083.5 551L1117.5 576M1083.5 551L1104 484M1083.5 551L1159.5 538M1083.5 551L1054.5 535.5M1068 559L1054.5 535.5M1093.5 576H1117.5M1117.5 576L1159.5 538M1117.5 576L1159.5 572M1159.5 538L1192.5 508M1159.5 538L1189.5 563M1159.5 538L1104 484M1159.5 538V572M1159.5 538L1214 541M1159.5 538L1174 488M1192.5 508L1214 541M1192.5 508L1174 488M1214 541L1189.5 563M1214 541L1215 571.5L1189.5 563M1214 541L1212.5 511M1214 541L1245.5 526M1189.5 563L1159.5 572M1189.5 563L1188.5 585M1104 484L1054.5 535.5M1104 484L1064 455.5M1104 484L1159.5 460.5M1104 484H1054.5M1104 484L1097.5 439M1104 484L1174 488M1054.5 535.5L1035.5 510.5M1054.5 535.5V484M1064 455.5L1054.5 484M1064 455.5L1075.5 444M1159.5 460.5L1108.5 430M1159.5 460.5L1174 466.5M1108.5 430L1097.5 439M1108.5 430L1089 419M1108.5 430L1146 389M1108.5 430L1150 423M1097.5 439L1075.5 444M1057 447L1075.5 444M1054.5 484L1035.5 510.5M1174 488H1184.5M1089 419L1075.5 444M1159.5 572L1188.5 585M1122.5 318L1158 326.5M1122.5 318V296.5M1146 389L1142.5 352M1146 389L1156.5 394.5M1142.5 352L1144 307M1150 423L1156.5 394.5M1150 423L1168 436.5M1156.5 394.5L1162 377.5M1156.5 394.5L1158 326.5M1162 377.5L1156.5 364.5L1214 344M1162 377.5L1214 344M1162 377.5L1196 389M1162 377.5L1164.5 416M1184.5 466.5V488M1184.5 466.5H1174M1184.5 466.5L1203.5 431M1184.5 466.5L1236 464M1184.5 488H1203.5M1174 466.5L1168 436.5M1203.5 431L1245 394.5M1203.5 431L1196 389M1203.5 431L1164.5 416M1203.5 431L1168 436.5M1203.5 431L1236 464M1203.5 431L1233.5 439.5M1203.5 431L1248 425.5M1245 394.5L1196 389M1245 394.5L1248 425.5M1245 394.5L1253 376L1214 344M1245 394.5L1258 423M1245 394.5L1232.5 344M1196 389L1214 344M1196 389L1164.5 416M1214 344L1232 342M1214 344L1158 326.5M1214 344L1205 325M1164.5 416L1168 436.5M1203.5 488L1236 464M1203.5 488L1212.5 511M1236 464L1233.5 439.5M1236 464L1248 455M1236 464L1212.5 511M1236 464L1243 495M1236 464L1252 484.5L1243 495M1233.5 439.5L1248 425.5M1248 425.5V455M1248 425.5L1258 423M1248 455L1752 491.5M1232 342L1725 277.5M1232 342L1205 325M1232 342L1232.5 344M1188.5 585L1772.5 763M1212.5 511L1243 495M1212.5 511L1245.5 526M1243 495L1245.5 526M1245.5 526L1695.5 473.5M1258 423L1746 194M1144 307L1174 315.5M1144 307L1137 296.5M1144 307L1176.5 289M1144 307L1122.5 296.5M1158 326.5L1174 315.5M1174 315.5L1176.5 289M1174 315.5L1191.5 286M1174 315.5L1205 325M1176.5 289L1191.5 286M1176.5 289L1160 283M1191.5 286V275M1191.5 286L1216.5 315.5M1191.5 286L1216.5 298M1191.5 275L1160 283M1191.5 275L1161 272M1160 283L1137 296.5M1160 283L1161 272M1137 296.5L1133.5 277.5M1137 296.5H1122.5M1133.5 277.5L1122.5 296.5M1133.5 277.5L1093 261M1133.5 277.5L1146 257M1133.5 277.5L1161 272M1122.5 296.5L1093 261M1146 257L1173 246.5M1173 246.5L1141 224M1173 246.5L1706.5 42.5M1173 246.5L1690.5 620.5M1112 178L1725 104.5M1044 173.5L1029.5 155M1029.5 155L1197.5 -34M1205 325L1216.5 315.5M1216.5 315.5V298M1216.5 315.5L1232.5 344M1216.5 298L1376.5 -20.5M1162 261L1161 272",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685,
    cy: 388,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 327,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505,
    cy: 418,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 398,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 398,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 388,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 701,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 748,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 162,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 665,
    cy: 226,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765,
    cy: 233,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 216,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 956,
    cy: 330,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1032,
    cy: 270,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1097,
    cy: 77,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1108,
    cy: 428,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1212,
    cy: 511,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 901,
    cy: 438,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 881,
    cy: 501,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 682,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094,
    cy: 840,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1198,
    cy: 840,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1295,
    cy: 335,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1499,
    cy: 306,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1489,
    cy: 474,
    r: 10,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_1636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.72d860849992a7ba12118ab20008acb5.svg";
export { ForwardRef as ReactComponent };